import React, { Component } from 'react';
import LeftBar from '../Site/LeftBar';
import AlertList from './AlertList';

import './style.css';

class Alerts extends Component {

  render() {
    return (
      <div>
        <LeftBar />
        <AlertList />
      </div>    


    );
  }
}

export default Alerts;